<template>
  <component :is="layoutComponent">
    <router-view />
  </component>
</template>

<script>
export default {
  name: 'App',
  computed: {
    layoutComponent () {
      return this.$route.meta.layout || 'div'
    }
  }
}
</script>

<style>
  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
      Arial, sans-serif !important;
  }
  h3 {
    font-weight: 400;
    font-size: 30px;
  }
  h5 {
    font-weight: 400;
    font-size: 22px;
  }
  .page {
    padding: 3rem 2rem 3rem 2rem;
  }
  .btn-primary {
    background-color: #0597F2 !important;
  }
  .pointer {
    cursor: pointer;
  }
  .unselectable {
    user-select: none;
  }
  .over-swal {
    z-index: 999999 !important;
  }
</style>
